import React, { useState, useRef } from "react";
import { MDBTooltip } from "mdb-react-ui-kit";
import { errorHandler } from "../ErrorHandler";
import ApiCall from "../../constants/Api";
import { helpAxios } from "../../helpers/helpAxios";
import OpenBetsModal from "../modals/OpenBetsModal";
import HistoryModal from "../modals/HistoryModal";
import SiteConfig from "../../constants/SiteConfig";
import ErrorCodes from "../../constants/ErrorCodes";

const Header = ({
  logout,
  playerLogout,
  getCodePlayerLogin,
  loginPlayerInfo,
  statisticsPlayer,
  getTimeUTCFormat,
  getDateUTCFormat,
  formPlayer,
  setFormPlayer,
  getStatistics,
  playerCode,
  session,
  publicIP,
  setSessionNoLongerExists,
}) => {
  let playerLog, btnPlayer;

  const [openBetsInfo, setOpenBetsInfo] = useState([]);
  const [historySummaryInfo, setHistorySummaryInfo] = useState([]);
  const [historyTransactInfo, setHistoryTransactInfo] = useState([]);
  const [historyFilters, setHistoryFilters] = useState({
    StartDate: new Date(),
    EndDate: new Date(),
    TicketNumber: "",
    FilterText: "",
    ClassicView: true,
  });
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [startDateSummary, setStartDateSummary] = useState(new Date());
  const [stateThisWeekButton, setStateThisWeekButton] = useState(false);
  const [balanceForward, setBalanceForward] = useState({ BalanceForward: 0 });
  const [loading, setLoading] = useState(false);
  const [roBalanceForwardTransact, setRoBalanceForwardTransact] = useState("");
  const [fpBalanceForwardTransact, setFpBalanceForwardTransact] = useState("");
  const [balanceForwardTransact, setBalanceForwardTransact] = useState("");
  const inputRef = useRef(null);
  const [wagerDetails, setWagerDetails] = useState({});
  const [historyDetails, setHistoryDetails] = useState({});
  const [actionDetails, setActionDetails] = useState({});
  const [openBetDetails, setOpenBetDetails] = useState({});
  const [wagerErrorModal, setWagerErrorModal] = useState(true);

  let x, x1, x2;

  //Onchange de player
  const handlePlayerChange = (e) => {
    setFormPlayer({
      ...formPlayer,
      [e.target.name]: e.target.value.toUpperCase(),
    });
  };

  //Mensaje de error si faltan datos en el Login Player
  const handleSubmitPlayer = () => {
    if (!formPlayer.playerName) {
      errorHandler("Incomplete data");
      return;
    }
    getCodePlayerLogin(formPlayer);
  };

  function calculateDays(fecha, dias) {
    fecha.setDate(fecha.getDate() + dias);
    return fecha;
  }

  const handleKeyPress = (event) => {
    if (event.key === "Enter" && inputRef.current === document.activeElement) {
      event.preventDefault();

      if (formPlayer.playerName.trim() !== "") {
        handleSubmitPlayer();
      }

      inputRef.current.blur();
    }
  };

  function addCommas(nStr) {
    nStr += "";
    x = nStr.split(".");
    x1 = x[0];
    x2 = x.length > 1 ? "." + x[1] : "";
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, `$1,$2`);
    }
    return x1 + x2;
  }

  //Validar Login del Player para colocar el botón que se requiere
  if (loginPlayerInfo.IdPlayer !== 0) {
    playerLog = (
      <>
        <div>
          <div className="dropdown dropdown-user" style={{ margin: "0px" }}>
            <a
              href="#nolink"
              className="lead"
              data-toggle="dropdown"
              style={{ color: "#ffffff" }}
            >
              {localStorage.getItem("playerName")}
            </a>
            <div className="dropdown-menu mt-2" style={{ width: "200px" }}>
              <button
                className="dropdown-item font-weight-bolder"
                href="#"
                style={{ color: "#8c8c8c" }}
              >
                Code:{" "}
                <span style={{ fontWeight: "normal" }}>{playerCode.Code}</span>
              </button>
            </div>
          </div>

          <div className="dropdown dropdown-user" style={{ margin: "0px" }}>
            <a
              href="#nolink"
              className="lead"
              data-toggle="dropdown"
              style={{ color: "#ffffff" }}
            >
              {loginPlayerInfo.Currency}{" "}
              {statisticsPlayer?.Balance
                ? addCommas(statisticsPlayer?.Balance)
                : addCommas(statisticsPlayer?.AvailBalance)}
            </a>
            <div className="dropdown-menu mt-2" style={{ width: "250px" }}>
              <button
                className="dropdown-item font-weight-bolder"
                href="#"
                style={{ color: "#8c8c8c" }}
              >
                Credit Limit:
                <span style={{ fontWeight: "normal" }}>
                  {loginPlayerInfo.CurrencySymbol}{" "}
                  {statisticsPlayer.CreditLimit}
                </span>
              </button>
              <button
                className="dropdown-item font-weight-bolder"
                href="#"
                style={{ color: "#8c8c8c" }}
              >
                At Risk:
                <span style={{ fontWeight: "normal" }}>
                  {" "}
                  {loginPlayerInfo.CurrencySymbol}{" "}
                  {statisticsPlayer.AmountAtRisk}
                </span>
              </button>
              <hr />
              <button
                className="dropdown-item font-weight-bolder"
                href="#"
                style={{ color: "#8c8c8c" }}
              >
                This Week:
                <span style={{ fontWeight: "normal" }}>
                  {" "}
                  {loginPlayerInfo.CurrencySymbol}{" "}
                  {statisticsPlayer.ThisWeekHorses}
                </span>
              </button>
              <button
                className="dropdown-item font-weight-bolder"
                href="#"
                style={{ color: "#8c8c8c" }}
              >
                Last Week:
                <span style={{ fontWeight: "normal" }}>
                  {" "}
                  {loginPlayerInfo.CurrencySymbol}
                  {statisticsPlayer.LastWeekHorses}
                </span>
              </button>
            </div>
          </div>
        </div>

        <button
          type="button"
          className="btn btn-icon btn-danger ml-4 mt-2"
          style={{
            borderRadius: "50%",
          }}
          onClick={() => playerLogout(setFormPlayer)}
        >
          <MDBTooltip tag="i" wrapperProps={{ href: "#" }} title="Logout">
            <i className="feather icon-unlock"></i>
          </MDBTooltip>
        </button>
      </>
    );
    btnPlayer = (
      <>
        <div
          className="navbar-nav mr-5"
          style={{
            borderRight: "1px solid #99ddff",
            height: "50px",
          }}
        >
          <div className="mt-3">
            <a
              href="#nolink"
              className="mr-4"
              style={{
                textDecoration: "none",
                color: "#ffffff",
                fontSize: "25px",
              }}
              data-toggle="modal"
              data-target="#openBetsModal"
              onClick={() => getOpenBetsModal()}
            >
              <MDBTooltip
                tag="i"
                wrapperProps={{ href: "#" }}
                title="Open Bets"
              >
                <i className="feather icon-file-text" />
              </MDBTooltip>
            </a>

            <a
              href="#nolink"
              className="mr-5"
              style={{
                textDecoration: "none",
                color: "#ffffff",
                fontSize: "23px",
              }}
              data-toggle="modal"
              data-target="#historyModal"
              onClick={() => getHistoryTransactModal(false)}
            >
              <MDBTooltip tag="i" wrapperProps={{ href: "#" }} title="History">
                <i className="fas fa-history" />
              </MDBTooltip>
            </a>
          </div>
        </div>
      </>
    );
  } else {
    playerLog = (
      <>
        <div>
          <input
            type="text"
            placeholder="Player Name"
            id="playerName"
            name="playerName"
            onChange={handlePlayerChange}
            value={formPlayer.playerName || ""}
            className="form-control"
            style={{ textTransform: "uppercase" }}
            ref={inputRef}
            onKeyDown={handleKeyPress}
          />
        </div>
        <button
          type="button"
          className="btn btn-icon btn-success ml-2"
          style={{
            borderRadius: "50%",
          }}
          onClick={() => handleSubmitPlayer()}
        >
          <MDBTooltip tag="i" wrapperProps={{ href: "#" }} title="Login">
            <i className="feather icon-lock"></i>
          </MDBTooltip>
        </button>
      </>
    );
  }

  //Función para cargar la info de los Open Bets (Modal)
  const getOpenBetsModal = () => {
    const fetchData = async () => {
      const res = await helpAxios(
        SiteConfig.PLAYER_HISTORY_SVC,
        ApiCall.INTERNAL_GET_OPEN_BETS,
        {
          IDPlayer: loginPlayerInfo.IdPlayer,
        },
        session,
      );

      if (res.error) {
        let errorDet;
        if (res.errorDetails) {
          errorDet = res.errorDetails;
        }
        if (
          res.Result === ErrorCodes.InvalidSession ||
          res.Result === ErrorCodes.SessionNoLongerExists
        ) {
          setSessionNoLongerExists(true);
        } else {
          errorHandler(res.error, errorDet);
        }
      } else {
        setOpenBetsInfo(res.List);
      }
    };

    fetchData();
  };

  const convertDateHistory = (date) => {
    // Crear un objeto Date con la fecha original
    const newDate = new Date(date);

    // Establecer la hora en 00:00:00 y convertir a UTC
    newDate.setHours(0, 0, 0, 0);
    const dateUTC = newDate.toISOString();

    // Retornar la fecha en formato deseado
    return dateUTC;
  };

  const getStartWeekDate = (date) => {
    const dayOfWeek = date.getDay();

    // Calculate how many days to go backward to get to Monday
    const daysToMonday = dayOfWeek === 0 ? 6 : dayOfWeek - 1;

    // Clone the date and move the calculated number of days backward
    const startDate = new Date(date);
    startDate.setDate(date.getDate() - daysToMonday);

    // Adjust the hours, minutes, and seconds to zero
    startDate.setHours(0, 0, 0, 0);

    // Format the date in the desired format
    const startDateWeek = startDate.toISOString().slice(0, 23) + "Z";

    return startDateWeek;
  };

  //Función para cargar la info del History Summary (Modal)
  const getHistorySummaryModal = (date, datePicker) => {
    const starWeekDate = getStartWeekDate(date);

    if (datePicker) {
      setStateThisWeekButton(false);
    }
    setStartDateSummary(date);
    const fetchData = async () => {
      setLoading(true);
      const res = await helpAxios(
        SiteConfig.PLAYER_HISTORY_SVC,
        ApiCall.GET_INTERNAL_SUMMARY,
        {
          SessionInfo: {
            IDPlayer: loginPlayerInfo.IdPlayer,
            IDCall: loginPlayerInfo.IdCall,
            IP: publicIP,
            PhoneLine: SiteConfig.LOGIN_PHONE_LINE,
          },
          AccountInfo: {
            Account: loginPlayerInfo.Player,
          },
          StartWeekDate: starWeekDate,
        },
        session,
      );

      if (res.error) {
        let errorDet;
        if (res.errorDetails) {
          errorDet = res.errorDetails;
        }
        if (
          res.Result === ErrorCodes.InvalidSession ||
          res.Result === ErrorCodes.SessionNoLongerExists
        ) {
          setSessionNoLongerExists(true);
        } else {
          errorHandler(res.error, errorDet);
        }
      } else {
        setHistorySummaryInfo(res.List);
        setBalanceForward(res.BalanceForward);
      }
      setLoading(false);
    };

    fetchData();
  };

  //Función para cargar la info del History Summary (Modal)
  const getHistoryTransactModal = (filter) => {
    let ticketNumber, startDate;
    if (historyFilters.TicketNumber !== "") {
      ticketNumber = parseInt(historyFilters.TicketNumber);
    } else {
      ticketNumber = null;
    }

    if (!filter) {
      setStartDate(calculateDays(new Date(), -6));
      startDate = calculateDays(new Date(), -6);
      getHistorySummaryModal(new Date(), false);
    } else {
      startDate = historyFilters.StartDate;
    }

    const fetchData = async () => {
      setLoading(true);

      //Calling method Internal/GetHistory from playerhistorysvc
      const res = await helpAxios(
        SiteConfig.PLAYER_HISTORY_SVC,
        ApiCall.GET_INTERNAL_HISTORY,
        {
          SessionInfo: {
            IDPlayer: loginPlayerInfo.IdPlayer,
            IDCall: loginPlayerInfo.IdCall,
            IP: publicIP,
            PhoneLine: SiteConfig.LOGIN_PHONE_LINE,
          },
          AccountInfo: {
            Account: loginPlayerInfo.Player,
          },
          FilterText: historyFilters.FilterText,
          StartDate: convertDateHistory(startDate),
          EndDate: convertDateHistory(historyFilters.EndDate),
          TicketNumber: ticketNumber ?? 0,
          OffSet: SiteConfig.OFF_SET,
          Rows: SiteConfig.ROWS,
        },
        session,
      );

      if (res.error) {
        let errorDet;
        if (res.errorDetails) {
          errorDet = res.errorDetails;
        }
        if (
          res.Result === ErrorCodes.InvalidSession ||
          res.Result === ErrorCodes.SessionNoLongerExists
        ) {
          setSessionNoLongerExists(true);
        } else {
          errorHandler(res.error, errorDet);
        }
      } else {
        setHistoryTransactInfo(res.List);
        setBalanceForwardTransact(res.BalanceForward);
        setRoBalanceForwardTransact(res.ROBalanceForward);
        setFpBalanceForwardTransact(res.FPBalanceForward);
      }
      setLoading(false);
    };

    fetchData();
  };

  const getWagerDetailModal = (IDWager) => {
    const fetchData = async () => {
      setLoading(true);

      const res = await helpAxios(
        SiteConfig.PLAYER_HISTORY_SVC,
        ApiCall.GET_WAGER_DETAILS,
        {
          IDWager: IDWager,
        },
        session,
      );

      if (res.error) {
        let errorDet;
        if (res.errorDetails) {
          errorDet = res.errorDetails;
        }
        if (
          res.Result === ErrorCodes.InvalidSession ||
          res.Result === ErrorCodes.SessionNoLongerExists
        ) {
          setSessionNoLongerExists(true);
        } else {
          errorHandler(res.error, errorDet);
        }
      } else {
        setWagerDetails(res.Wager);
      }
      setLoading(false);
    };

    fetchData();
  };

  const getHistoryDetailModal = (IDTransaction) => {
    const fetchData = async () => {
      setLoading(true);

      const res = await helpAxios(
        SiteConfig.PLAYER_HISTORY_SVC,
        ApiCall.GET_TRANSACTION_DETAILS,
        {
          IDTransaction: IDTransaction,
        },
        session,
      );

      if (res.error) {
        let errorDet;
        if (res.errorDetails) {
          errorDet = res.errorDetails;
        }
        if (
          res.Result === ErrorCodes.InvalidSession ||
          res.Result === ErrorCodes.SessionNoLongerExists
        ) {
          setSessionNoLongerExists(true);
          setWagerErrorModal(true);
        } else {
          setWagerErrorModal(true);
          errorHandler(res.error, errorDet);
        }
      } else {
        setWagerErrorModal(false);
        setHistoryDetails(res.Details);
      }
      setLoading(false);
    };

    fetchData();
  };

  const getActionDetailModal = (ticketNumber) => {
    const fetchData = async () => {
      setLoading(true);

      const res = await helpAxios(
        SiteConfig.PLAYER_HISTORY_SVC,
        ApiCall.GET_HISTORY_ACTION_DETAILS,
        {
          IDPlayer: loginPlayerInfo.IdPlayer,
          TicketNumber: ticketNumber,
        },
        session,
      );

      if (res.error) {
        let errorDet;
        if (res.errorDetails) {
          errorDet = res.errorDetails;
        }
        if (
          res.Result === ErrorCodes.InvalidSession ||
          res.Result === ErrorCodes.SessionNoLongerExists
        ) {
          setSessionNoLongerExists(true);
        } else {
          errorHandler(res.error, errorDet);
        }
      } else {
        setActionDetails(res.List);
      }
      setLoading(false);
    };

    fetchData();
  };

  const getOpenBetsDetailModal = (IDWager) => {
    const fetchData = async () => {
      setLoading(true);

      const res = await helpAxios(
        SiteConfig.PLAYER_HISTORY_SVC,
        ApiCall.GET_OPEN_BETS_DETAILS,
        {
          IDWager: IDWager,
        },
        session,
      );

      if (res.error) {
        let errorDet;
        if (res.errorDetails) {
          errorDet = res.errorDetails;
        }
        if (
          res.Result === ErrorCodes.InvalidSession ||
          res.Result === ErrorCodes.SessionNoLongerExists
        ) {
          setSessionNoLongerExists(true);
        } else {
          errorHandler(res.error, errorDet);
        }
      } else {
        setOpenBetDetails(res.OpenBet);
      }
      setLoading(false);
    };

    fetchData();
  };

  const logoutUser = () => {
    if (loginPlayerInfo.IdPlayer !== 0) {
      playerLogout(setFormPlayer);
    }
    logout(true);
  };

  return (
    <header className="navbar pcoded-header navbar-expand-lg headerpos-fixed">
      <OpenBetsModal
        playerName={localStorage.getItem("playerName")}
        openBetsInfo={openBetsInfo}
        setOpenBetsInfo={setOpenBetsInfo}
        getTimeUTCFormat={getTimeUTCFormat}
        loginPlayerInfo={loginPlayerInfo}
        getDateUTCFormat={getDateUTCFormat}
        loading={loading}
        getStatistics={getStatistics}
        session={session}
        setSessionNoLongerExists={setSessionNoLongerExists}
        setOpenBetDetails={setOpenBetDetails}
        openBetDetails={openBetDetails}
        getOpenBetsDetailModal={getOpenBetsDetailModal}
      />
      <HistoryModal
        playerName={localStorage.getItem("playerName")}
        getHistoryTransactModal={getHistoryTransactModal}
        historyTransactInfo={historyTransactInfo}
        getDateUTCFormat={getDateUTCFormat}
        getTimeUTCFormat={getTimeUTCFormat}
        historyFilters={historyFilters}
        setHistoryFilters={setHistoryFilters}
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEndDate={setEndDate}
        setStartDateSummary={setStartDateSummary}
        startDateSummary={startDateSummary}
        getHistorySummaryModal={getHistorySummaryModal}
        historySummaryInfo={historySummaryInfo}
        calculateDays={calculateDays}
        stateThisWeekButton={stateThisWeekButton}
        setStateThisWeekButton={setStateThisWeekButton}
        balanceForward={balanceForward}
        loading={loading}
        balanceForwardTransact={balanceForwardTransact}
        roBalanceForwardTransact={roBalanceForwardTransact}
        fpBalanceForwardTransact={fpBalanceForwardTransact}
        convertDateHistory={convertDateHistory}
        addCommas={addCommas}
        getWagerDetailModal={getWagerDetailModal}
        wagerDetails={wagerDetails}
        setWagerDetails={setWagerDetails}
        loginPlayerInfo={loginPlayerInfo}
        getHistoryDetailModal={getHistoryDetailModal}
        historyDetails={historyDetails}
        getActionDetailModal={getActionDetailModal}
        actionDetails={actionDetails}
        wagerErrorModal={wagerErrorModal}
        getOpenBetsDetailModal={getOpenBetsDetailModal}
        openBetDetails={openBetDetails}
      />
      <div
        className="m-header ml-2"
        style={{ borderRight: "1px solid #99ddff", height: "50px" }}
      >
        <div className="mt-3">
          <a
            href="index.html"
            className="b-brand mr-3"
            style={{ textDecoration: "none" }}
          >
            <span
              className="b-title font-weight-bolder"
              style={{ color: "#99ddff" }}
            >
              Racing Client
            </span>
          </a>
        </div>
      </div>
      <button className="mobile-menu" id="mobile-header" href="#">
        <i className="feather icon-more-horizontal" />
      </button>
      <div className="collapse navbar-collapse">
        <div className="ml-4 row">{playerLog}</div>

        <ul className="navbar-nav ml-auto">
          {btnPlayer}
          <li className="dropdown drp-user">
            <a
              className="mr-2"
              href="#nolink"
              id="navbarDropdownMenuLink"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i
                className="fas fa-user-circle"
                style={{ color: "#ffffff", fontSize: "23px" }}
              />
            </a>
            <div
              className="dropdown-menu dropdown-menu-right profile-notification mr-3"
              style={{ borderRadius: "40px" }}
            >
              <div
                className="pro-head"
                style={{ textAlign: "center", height: "50px" }}
              >
                <span
                  style={{
                    fontWeight: "bold",
                    fontSize: "18px",
                  }}
                >
                  {localStorage.getItem("userName")}
                </span>
              </div>
              <ul className="pro-body">
                {/* <li>
                  <a href="#" className="dropdown-item">
                    <i className="feather icon-settings"></i> Settings
                  </a>
                </li>
                <li>
                  <a href="#" className="dropdown-item">
                    <i className="feather icon-user"></i> Profile
                  </a>
                </li>
                <li>
                  <a href="#" className="dropdown-item">
                    <i className="feather icon-info"></i> About
                  </a>
                </li> */}
                <li>
                  <button
                    href="#"
                    className="dropdown-item"
                    onClick={() => logoutUser()}
                  >
                    <i className="feather icon-log-out"></i> Logout
                  </button>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </header>
  );
};

export default Header;
